import React, { useState, useEffect, Fragment } from 'react';
import Box from '@mui/material/Box';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import CategoriesAccordion from './CategoriesAccordion';

const Categories3 = ({ route, prettified_categories }) => {
  const router = useRouter();
  const breadcrumbs = useSelector(state => state.globalReducer.breadcrumbs);
  const findCurrCat = () => {
 		//init values object
		//this is to store the idx's of the category and subcategory (open/closed state)
		let values = {
			category: null,
			sub_category: null
		};

		//attempt to find category index
		const breadcrumbSlugs = Object.values(breadcrumbs?.links || []);
		const index = prettified_categories.findIndex(category => category.slug == router.query.route );

		//if it is found, set the values.category to the index
		if(index != -1) {values['category'] = index}

		//otherwise we loop through the sons
		else {
			prettified_categories.map((category, idx) => {
				if(category.sons.length != 0){
					//attempt to find sub cat index
					const foundSubRoute = category.sons.findIndex(sub_cat => sub_cat.slug == router.query.route);

					//if it is found and the index is not yet defined, update the object
					if(foundSubRoute != -1 && values['sub_category'] == null){
						values['category'] = idx;
						values['sub_category'] = foundSubRoute;
					}
				}
			})
		}
		
		/**
		 * Return object of: 
		 * {
		 * 		category: idx,
		 * 		sub_category: idx
		 * }
		 */
		return values;
  };



  return (
    <Box className="pl-1" sx={{ width: '95%' }}>
		{prettified_categories.map((category, idx) => (
			category?.parent_id === 0 && category?.visible === 'yes' &&
			<Fragment key={category.name}>
				<CategoriesAccordion
					idx={idx}
					route={route}
					category={category}
					findCurrCat={findCurrCat}
				/>
			</Fragment>
		))}
    </Box>
  );
};

export default React.memo(Categories3);